import React, { Fragment } from "react";
import { MainPagesSectionHeader } from "./components/MainPagesSectionHeader";

const quoteStyle: React.CSSProperties = {
  borderLeft: "4px solid var(--primary-color)",
  paddingLeft: "2rem",
  margin: "0 0 2.5rem",
  fontStyle: "italic",
  fontSize: "2.6rem",
  lineHeight: 1.35,
  color: "var(--primary-color)",
};

export const MainPagesCompany = () => {
  return (
    <Fragment>
      <section className="u-bgPrimaryLightest u-pb-6r u-pt-10r">
        <div className="container">
          <MainPagesSectionHeader title="Empresa" />
          {/* VIDEO */}
          <div className="l-flex u-mb-4r">
            <iframe
              width="727"
              height="409"
              src="https://www.youtube.com/embed/qNzuMdmLWJQ"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <div className="companyText">
            <p>
              El Hospital Veterinario Peninsular es una empresa con más de 30
              años de experiencia y la primera en su tipo en el sureste de
              México. Es el primer Hospital Veterinario en la ciudad de Mérida y
              abre sus puertas el 26 de noviembre de 1990.
            </p>
            <p>
              Su objetivo fue crear un hospital con todo lo necesario para que
              una mascota pueda encontrar los servicios médicos, quirúrgicos y
              de diagnóstico especializados en los animales de compañía.
            </p>
            <p>
              El fundador, MVCA Rafael A. García López, siendo yucateco de
              nacimiento y habiendo tenido desde pequeño muchas mascotas, tuvo
              la visión de estudiar en la ciudad de Puebla, donde existían
              estudios especializados en la clínica de animales de compañía, en
              la Universidad Cuetlaxcoapan, ahora Universidad Mesoamericana
              Campus Puebla.
            </p>
            <p>
              La vanguardia en la tecnología es su distinción; es una referencia
              médica en diversas áreas de la especialidad y únicos en el sureste
              mexicano practicando cirugía de cataratas con facoemulsificación
              (técnica de mínima invasión).
            </p>
            <p>
              La oportunidad de servirle es una de sus metas, su colaboración
              con ella es muy valiosa y unidos lograrán con sus mascotas un
              lugar de plenitud en la localidad.
            </p>
          </div>
        </div>
      </section>

      <section className="u-bgPrimaryLighter u-pb-6r">
        <div className="container">
          <MainPagesSectionHeader title="Misión, visión y valores" />
          <div className="companyText">
            <h3 className="heading--tertiary">Misión</h3>
            <p>
              La misión de la empresa es ofrecer servicios veterinarios con la
              calidez y atención que merecen las mascotas, valorándolas por lo
              que son y lo que hoy representan.
            </p>
            <h3 className="heading--tertiary">Visión</h3>
            <p>
              La visión es ser el modelo de atención veterinaria de todo el
              sureste del país.
            </p>
            <h3 className="heading--tertiary">Valores</h3>
            <p>
              Los valores son el profesionalismo, la empatía, la calidad, el
              desarrollo de los trabajadores, la responsabilidad social y la
              honestidad.
            </p>
          </div>
        </div>
      </section>

      <section className="u-bgPrimaryLightest u-pb-6r">
        <div className="container">
          <MainPagesSectionHeader title="Logo, eslogan y mascota" />

          <div className="companyText">
            <h3 className="heading--tertiary">Eslogan</h3>
            <blockquote style={quoteStyle}>
              «El especialista en cuestión siempre es la mejor opción.»
            </blockquote>
            <p>
              Nuestro director médico es especialista en la salud de las
              mascotas y disfruta profundamente su labor; es, además, un
              convencido de que cuidar a los animales es también una forma de
              servir a las personas. En el hospital estamos siempre abiertos a
              escuchar a nuestros clientes: sus consejos, comentarios y
              sugerencias nos ayudan a ser mejores cada día.
            </p>
            <p>
              Ser el especialista en cuestión define la pasión y la entrega con
              la que se realiza cualquier actividad que además se disfruta,
              logrando ofrecer un servicio de referencia que posee conocimientos
              y experiencias de vanguardia.
            </p>
            <p>
              Este eslogan resume en breves líneas una vida de congruencia entre
              todo aquello que se sueña y se desea, con lo que se practica
              físicamente. Por lo tanto… en cualquier menester de la vida,
              recurrir con el especialista en cuestión siempre es la mejor
              opción.
            </p>

            <h3 className="heading--tertiary">Logo</h3>
            <div
              className="l-flex u-mb-2r"
              style={{ justifyContent: "center" }}
            >
              <img
                src="assets/imgs/mainPage/HVPLogo_no_bg.png"
                alt="Logotipo del Hospital Veterinario Peninsular"
                style={{ maxWidth: "220px", width: "100%", height: "auto" }}
              />
            </div>
            <p>Nuestro logotipo contiene una triada:</p>
            <ol style={{ paddingLeft: "2.5rem", lineHeight: 1.6 }}>
              <li style={{ marginBottom: "1.2rem" }}>
                De perfil es un perro de raza terrier, inspirado en el terrier
                escocés de nombre Shandree que existió en nuestras vidas y lo
                hemos personificado con una botarga que es la mascota de la
                empresa y nos ayuda a promoverla.
              </li>
              <li style={{ marginBottom: "1.2rem" }}>
                Visto de frente y compartiendo el único ojo del logotipo se
                aprecia la cara de un gato cuya nariz es el centro del mismo y
                se aprecian sus bigotes.
              </li>
              <li style={{ marginBottom: "1.2rem" }}>
                Las manos del hombre que, como propietario, los arropan: casi
                topan los cuatro dedos largos de ambas manos con el pulgar sobre
                ellos; la extensión de los brazos forma una V de victoria y de
                veterinaria, nuestra profesión amada que nos dio los
                conocimientos para cuidar a las mascotas.
              </li>
            </ol>

            <h3 className="heading--tertiary">Mascota</h3>
            <p>
              La mascota del hospital se llama <strong>Shandree</strong>, la
              mascota más significativa de nuestro director médico, Rafael A.
              García López. Su silueta está en el logotipo y en el corazón de la
              empresa. Como muestra física de que nadie muere, Shandree existe
              en todas las moléculas de la canofilía bajo nuestra perspectiva, y
              mantenerla presente da testimonio de aliento para todos aquellos
              que pierden algo o a alguien. Enhorabuena.
            </p>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
